import type { ReleaseDraft } from '@seaa/shared'
import { useI18n } from '../../lib/i18n'

export function ReleaseContent({ release, language, onNavigate }: { release: ReleaseDraft; language?: 'ar' | 'en'; onNavigate?: () => void }) {
  const { locale } = useI18n()
  const lang = language ?? (locale === 'ar' ? 'ar' : 'en')
  const copy = release.content[lang]
  // Preview may contain a half-written URL; only render same-origin links.
  let target = new URL('/changelog', 'https://seaa.invalid')
  try {
    const candidate = new URL(release.destination, target.origin)
    if (candidate.origin === target.origin) target = candidate
  } catch { /* Keep the changelog destination while an admin is typing. */ }
  target.searchParams.set('lang', lang)
  return <div className="release-preview" lang={lang} dir={lang === 'ar' ? 'rtl' : 'ltr'}>
    <h3>{copy.title}</h3><p>{copy.summary}</p><ul>{copy.highlights.map((highlight, index) => <li key={index}>{highlight}</li>)}</ul>
    <a href={`${target.pathname}${target.search}${target.hash}`} onClick={onNavigate}>{copy.ctaLabel}</a>
  </div>
}
